import { render } from "./ImpersonationBanner.vue?vue&type=template&id=df19349e&scoped=true&lang=pug"
import script from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=js"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=df19349e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df19349e"]])

export default __exports__